import { render, staticRenderFns } from "./LottieMicroAniHandler.vue?vue&type=template&id=24af86cf&scoped=true&"
import script from "./LottieMicroAniHandler.vue?vue&type=script&lang=js&"
export * from "./LottieMicroAniHandler.vue?vue&type=script&lang=js&"
import style0 from "./LottieMicroAniHandler.vue?vue&type=style&index=0&id=24af86cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24af86cf",
  null
  
)

export default component.exports